/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable indent */
import React from 'react';
import { Link } from 'react-router-dom';
import './Li.css';

const notesClick = (linkKey, item) => {
	let toggleNote = (el) => {
		el.target.nextElementSibling.classList.toggle('hide');
	}

	let closeNote = (el) => {
		el.target.parentNode.classList.toggle('hide');
	}

	return (
		<div className="notesHolder">
			<p onClick={(e) => toggleNote(e)} className="notesSpan"> Notes </p>
			<div className="notesCont hide">
				<span className="closeX" onClick={(e) => closeNote(e)}>X</span>
				<p className="notesName">Notes for {item.firstName} {item.lastName} </p>
				<p>{item.notes}</p>
			</div>
		</div>
	);

};


const editClick = (linkKey, item) => {
	let editRoute = `${linkKey}/${item.id}`;
	let isactivated = item.isActive;
	if (isactivated) {
		return (
			<span className="edit"> <Link to={editRoute}>Edit</Link></span>
		);
	}
	else {
		return (
			<a><span id='activeToggle' className="editDisabled">Edit</span></a>
		);
	}


};


const deleteClick = (linkKey, item, clickMethod) => {

	let isactivated = item.isActive;
	if (isactivated) {
		return (
			<a onClick={() => window.confirm(`Inactivate item ${item.name}?`) ? clickMethod(item.id) : ""}><span id='activeToggle' className="delete" >Inactivate</span></a>
		);
	}
	else {
		return (
			// <a onClick={() => window.confirm(`Activate item ${item.name}?`) ? clickMethod(item.id) : ""}><span id='activeToggle' className="enable" >Activate</span></a>
			<a><span className="disable">Activate</span></a>
		);
	}

};

export default (props) => {
	return (
		< div >
			<ul className={props.LiList.liClass}>
				{
					props.LiList.items.length ?
						props.LiList.items.map((item, i) => {
							let newRoute = `${props.LiList.linkKey}/${item.id}`;
							let nameFetch = props.nameKey ? item[props.nameKey] : item.name;
							let bldgName = item.building !== undefined ? item.building.name : '';
							let floorName = item.floor !== undefined ? item.floor.name : '';
							return (
								<li key={i} name={nameFetch}>
									{props.hideEdit ?
										<span className="mainDesc">{nameFetch}</span> :
										<div>
											{(() => {
												switch (item.isActive) {
													case true: return (<div className="floorName">
														<span className="mainDesc"><Link to={newRoute} > {nameFetch} </Link></span>
													</div>);

													case false: return (<div className="floorName">
														<span className="mainDesc">{nameFetch}</span>
													</div>);
												}
											})()}

											<div className="nameWrap">
												{props.userLi && (item.firstName && item.lastName !== null) ?
													<div className="userName">
														<span className="building">{item.lastName}, {item.firstName} {item.middleName} </span>
													</div> :
													<div className="bldgName"><span className="building">{bldgName}</span></div>
												}
											</div>

											<div className="actions">
												{!item.notes ?
													null :
													notesClick(props.LiList.linkKey, item)
												}
												{props.hideEdit ?
													null :
													editClick(props.LiList.linkKey, item)
												}
												{
													props.showDelete ? deleteClick(props.LiList.linkKey, item, props.LiList.deleteClick) : ""
												}

											</div>
										</div>

									}

								</li>
							);
						})
						:
						<p>No Items</p>
				}
			</ul>
		</div >
	);
};


// WEBPACK FOOTER //
// ./src/Components/Li/Li.js